const ACTION_TYPE = "SINGLE_MEMORIALS";
export const GET_MEMORIAL_PAGE = `${ACTION_TYPE}/GET_PAGE`;
export const GET_MEMORIAL_PAGE_SUCCESS = `${ACTION_TYPE}/GET_MEMORIAL_PAGE_SUCCESS`;
export const GET_MEMORIAL_PAGE_FAILED = `${ACTION_TYPE}/GET_MEMORIAL_PAGE_FAILED`;
